<template>
  <page-option :disable-add="!checkAccess('key.create')" overflow-hidden>
    <template #title>
      <v-avatar color="#E3FCF7" size="35">
        <v-icon color="#108F6E" size>mdi-account</v-icon>
      </v-avatar>
      <div class="pl-2 title-page"> {{ $t('sidebar.key.name') }}</div>
    </template>
    <template #below-toolbar>
      <FilterSearch
        canShowInSearch
        v-model="params"
        :disableCreate="!checkAccess('key.create')"
        placeholder="Tìm kiếm theo tên"
        @click:create="onCreateItem()"
      >
        <div class="d-flex flex-sm-row flex-column flex-warp">
          <div class="filter-item">
            <field-group
              v-model="params.status"
              background-color="#FFFFFF"
              dense
              :items="status.items"
              :label="$t('active-title.title')"
              :loading="status.loading"
              no-label
              hide-details
              outlined
              typeInput="v-select"
              clearable
            >
            </field-group>
          </div>
          <div class="filter-item">
            <field-group
              v-model="params.created_by_id"
              background-color="#FFFFFF"
              dense
              :items="user.items"
              item-text="name"
              item-value="id"
              label="Người tạo"
              :loading="user.loading"
              no-label
              hide-details
              outlined
              typeInput="v-select"
              clearable
            >
            </field-group>
          </div>
          <div class="filter-item">
            <field-group
              v-model="params.workspace_id"
              background-color="#FFFFFF"
              clearable
              dense
              item-text="name"
              item-value="id"
              :items="workspace.items"
              :label="$t('sidebar.workspace.name')"
              :loading="workspace.loading"
              no-label
              outlined
              hide-details
              typeInput="v-select"
            >
            </field-group>
          </div>
        </div>
      </FilterSearch>
    </template>
    <v-sheet class="fillheight overflow-hidden">
      <base-serve-table
        ref="table"
        :api="api"
        :headers="headers"
        :params="params"
        :defaultParams="default_params"
      >
        <template v-slot:[`item.status`]="{ item }">
          <span>
            <p v-if="item.status == 0" class="red--text mb-0">Vô hiệu</p>
            <p v-if="item.status == 1" class="warning--text  mb-0"
              >Chờ phê duyệt</p
            >
            <p v-if="item.status == 2" class="green--text mb-0">Hoạt động</p>
          </span>
        </template>
        <template v-slot:[`item.updated_at`]="{ item }">
          <span>{{ item.updated_at | dateTime('short') }}</span>
        </template>
        <template v-slot:[`item.created_at`]="{ item }">
          <span>{{ item.created_at | dateTime('short') }}</span>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <base-button-group
            class="full-width"
            :items="menus"
            :value="item"
          ></base-button-group>
        </template>
      </base-serve-table>
    </v-sheet>
    <KeyDialog ref="dialog" @reset="onReset" :workspace="workspace" />
    <KeyGenerateUrlDialog ref="urlDialog" :workspace="workspace" />
  </page-option>
</template>

<script>
import FilterSearch from '@layouts/filter-search.vue'
import { API_KEY, API_WORKSPACE } from '@api'
import { ConfirmBuilder } from '@utils'
import { mapGetters } from 'vuex'
import { EDIT_TYPE } from '@constant'
import KeyDialog from './key-dialog.vue'
import KeyGenerateUrlDialog from './key-generate-url-dialog.vue'
import axios from '@service/auth-sdk'
export default {
  mixins: [],
  components: {
    FilterSearch,
    KeyDialog,
    KeyGenerateUrlDialog,
  },
  props: { option: { type: Object, default: () => ({ params: {} }) } },
  data: (vm) => ({
    workspace: {
      loading: false,
      items: [],
    },
    user: {
      loading: false,
      items: [],
    },
    status: {
      loading: false,
      items: [
        { text: 'Hoạt động', value: 2 },
        { text: 'Chờ phê duyệt', value: 1 },
        { text: 'Vô hiệu', value: 0 },
      ],
    },
    default_params: { with: 'created_by,workspaces' },
    params: { search: '', status: null, created_by_id: null },
    menus: [
      {
        title: 'Tạo đường dẫn',
        icon: 'mdi-source-branch',
        handler: (item) => vm.$refs.urlDialog.open(item),
        disabled: (item) => !vm.checkAccess('key.update', item),
      },
      {
        type: 'update',
        handler: (item) => vm.onUpdateItem(item),
        disabled: (item) => !vm.checkAccess('key.update', item),
      },
      {
        type: 'delete',
        handler: (item) => vm.onDeleteItem(item),
        disabled: (item) => !vm.checkAccess('key.delete', item),
      },
    ],
    headers: [
      {
        text: 'Tên hiển thị',
        align: 'start',
        sortable: true,
        value: 'name',
      },
      {
        text: 'Người tạo',
        align: 'start',
        sortable: 'created_by_id',
        value: 'created_by.name',
      },
      {
        text: 'Trạng thái',
        align: 'center',
        sortable: 'status',
        value: 'status',
        width: 120,
      },
      {
        text: 'Ngày tạo',
        align: 'start',
        sortable: true,
        value: 'created_at',
      },
      {
        text: 'Ngày cập nhật',
        align: 'start',
        sortable: true,
        value: 'updated_at',
      },
      {
        trans: 'field.action',
        value: 'action',
        sortable: false,
        width: '150px',
        align: 'center',
      },
    ],
    loading: false,
  }),
  watch: {},
  computed: {
    ...mapGetters({
      currentId: 'auth/currentId',
      currentUser: 'auth/currentUser',
    }),
    api() {
      return API_KEY
    },
  },
  created() {
    this.workspace.loading = true
    API_WORKSPACE.list()
      .then((res) => {
        this.workspace.items = res.data
      })
      .finally(() => {
        this.workspace.loading = false
      })
    this.user.loading = true
    axios.get('/users-id').then((response) => {
      this.user.items = response.data
      this.user.loading = false
    })
  },
  mounted() {},
  methods: {
    onResetPassword(item) {
      this.$refs.resetdialog.open(item)
    },
    async onDeleteItem(item) {
      let confirm = new ConfirmBuilder()
      confirm
        .addMessage('confirm.delete-name')
        .setTitle('confirm.title')
        .setOption({
          params: { name: item.username },
          color: 'error',
        })
        .setType('delete')
      if (await confirm.confirm()) {
        const result = await API_KEY.destroy(item.id, item)
        if (result.isDone) {
          this.onReset()
        }
        return result
      }
    },
    onCreateItem() {
      this.$refs.dialog.open({}, EDIT_TYPE.CREATE)
    },
    onUpdateItem(item) {
      this.$refs.dialog.open(item, EDIT_TYPE.UPDATE)
    },
    onReset() {
      this.$refs.table.reload()
    },
  },
}
</script>
